import { useQuery } from '@tanstack/react-query';
import { leadOpsApi } from '../api/leadOps';

type MeData = {
  username: string | null;
  monday_user_id: string | null;
  oauth_enabled: boolean;
  csrf_token?: string;
};

export const useAuth = () => {
  const query = useQuery<{ success: boolean; data: MeData }>({
    queryKey: ['lead-ops', 'me'],
    queryFn: () => leadOpsApi.getMe(),
    retry: false,
    staleTime: 30 * 1000,
  });

  const data = query.data?.data;
  const oauthEnabled = data?.oauth_enabled ?? false;
  const isAuthenticated = Boolean(data?.username);
  const showLoginPage = (oauthEnabled && !isAuthenticated) || (query.isError && !data);
  const mondayUserId = data?.monday_user_id;

  return {
    ...query,
    oauthEnabled,
    isAuthenticated,
    showLoginPage,
    username: data?.username ?? null,
    mondayUserId: mondayUserId ? parseInt(mondayUserId, 10) : undefined,
  };
};
